import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FloorDetails, SaveFloorData } from '../../floor-plan/models/Plan-Shaps';
import { ListFilter } from '../models/Floors';

@Injectable({
  providedIn: 'root'
})
export class FloorsService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/ResRestaurantFloors/ResGetAllRestaurantFloors`, filter);
  }
  GetDetails(id: number) {
    return this.http.get<FloorDetails>(`${environment.apiUrl}/ResRestaurantFloors/ResGetRestaurantFloorsById?id=${id}`);
  }
  delete(id: number) {
    return this.http.post(`${environment.apiUrl}/ResRestaurantFloors/ResDeleteRestaurantFloors?id=${id}`, null);
  }
  saveRecord(data: any) {
    if (data.id) {
      return this.http.post(`${environment.apiUrl}/ResRestaurantFloors/ResEditRestaurantFloors`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/ResRestaurantFloors/ResNewRestaurantFloors`, data);
    }
  }
  saveFloor(data: SaveFloorData) {
    return this.http.post(`${environment.apiUrl}/ResRestaurantFloors/ResSaveFloorsTables`, data);
  }
  activeDeactiveFloor(id: number, Stats: boolean) {
    return this.http.post(`${environment.apiUrl}/ResRestaurantFloors/ResActiveDeactiveFloor?floorId=${id}&Stats=${Stats}`, null);
  }
  getAllseating(id: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurantFloors/ResgetAllseating?RestaurantId=${id}`);
  }
  getAllRestaurantAmenity(id: number) {
    return this.http.get(`${environment.apiUrl}/ResRestaurantFloors/ResgetAllRestaurantAmenity?RestaurantId=${id}`);
  }
  getFloorShapes() {
    return this.http.get(`${environment.apiUrl}/ResRestaurantFloors/ResGetFloorShapes`);
  }
}
